// The LangSmith key the browser sends to the hosted LangGraph agents. CP-2 (CoPilot PRD) moves this
// to a pass-through on the Agents server so no key ships in the web page; until then it lives here,
// in one place.
export const LANGGRAPH_API_KEY: string | undefined = import.meta.env.VITE_LANGGRAPH_API_KEY;
